import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormSelectInput from '../general-input-form/FormSelectInput'

// helper
import { singleLetterNumberOptionSelect } from '../../../helpers/format-options'

const AppForm = ({
  values,
  errors,
  handleSelectInput
}) => {
  return (
    <>
      <CRow className="mb-4">
        <FormSelectInput 
          id='letter_type'
          name='letter_type'
          colSize='6'
          inputLabel='Letter Type'
          className='mb-3'
          selectOptions={singleLetterNumberOptionSelect()}
          value={values}
          handleSelectInput={(e) => handleSelectInput(e)}
          feedbackInvalid={errors ? 'Please select letter type.' : ''}
          invalid={errors}
          disabled={false}
          placeholder='Please select letter type...'
        />
      </CRow>
    </>
  )
}

export default AppForm